<template>
  <div>
    <a class="skip-link screen-reader-text" href="/">Skip to content</a>
    <div data-elementor-type="header" data-elementor-id="22" class="elementor elementor-22 elementor-location-header"
      data-elementor-post-type="elementor_library">
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-2e1fe9f0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="2e1fe9f0" data-element_type="section">
        <div class="elementor-container elementor-column-gap-default">
          <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e870205"
            data-id="e870205" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-490d929 elementor-widget-tablet__width-initial elementor-widget elementor-widget-theme-site-logo elementor-widget-image"
                data-id="490d929" data-element_type="widget" data-widget_type="theme-site-logo.default">
                <div class="elementor-widget-container">
                  <a href="/">
                    <img fetchpriority="high" width="915" height="537" src="/static/img/landing/logo-punslot168-1.webp"
                      class="attachment-full size-full wp-image-247" alt=""
                       sizes="(max-width: 915px) 100vw, 915px"> </a>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-29d00830"
            data-id="29d00830" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <section
                class="elementor-section elementor-inner-section elementor-element elementor-element-2e649cad elementor-hidden-mobile elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="2e649cad" data-element_type="section">
                <div class="elementor-container elementor-column-gap-default">
                  <div
                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-170c7f3b"
                    data-id="170c7f3b" data-element_type="column">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                  <div
                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-1662f62d"
                    data-id="1662f62d" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-2f1e3a0e elementor-align-justify elementor-widget elementor-widget-button"
                        data-id="2f1e3a0e" data-element_type="widget" data-widget_type="button.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-button-wrapper">
                            <a class="elementor-button elementor-button-link elementor-size-sm"
                              href="/login" target="_blank">
                              <span class="elementor-button-content-wrapper">
                                <span class="elementor-button-text">เข้าสู่ระบบ</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-142822d5"
                    data-id="142822d5" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-ac5947b elementor-align-justify elementor-widget elementor-widget-button"
                        data-id="ac5947b" data-element_type="widget" data-widget_type="button.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-button-wrapper">
                            <a class="elementor-button elementor-button-link elementor-size-sm"
                              href="/register" target="_blank">
                              <span class="elementor-button-content-wrapper">
                                <span class="elementor-button-text">สมัครสมาชิก</span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-645cfdb0 elementor-hidden-desktop elementor-hidden-tablet elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="645cfdb0" data-element_type="section">
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-50854aa0"
            data-id="50854aa0" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-545026f3 elementor-widget elementor-widget-image"
                data-id="545026f3" data-element_type="widget" data-widget_type="image.default">
              </div>
              <div class="elementor-element elementor-element-84a614d elementor-widget elementor-widget-image"
                data-id="84a614d" data-element_type="widget" data-widget_type="image.default">
                <div class="elementor-widget-container">
                  <a href="/login" target="_blank">
                    <img width="732" height="700" src="/static/img/landing/playnow-punslot168.webp"
                      class="elementor-animation-pulse attachment-large size-large wp-image-245"
                      alt="  แจกโบนัส "
                       sizes="(max-width: 732px) 100vw, 732px"> </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div data-elementor-type="wp-page" data-elementor-id="33" class="elementor elementor-33"
      data-elementor-post-type="page">
      
      <div class="elementor-element elementor-element-65b72b7 e-flex e-con-boxed e-con e-parent" data-id="65b72b7"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div
            class="elementor-element elementor-element-2be1315 elementor-widget elementor-widget-image-carousel e-widget-swiper"
            data-id="2be1315" data-element_type="widget"
            data-settings="{&quot;navigation&quot;:&quot;none&quot;,&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;autoplay_speed&quot;:5000,&quot;infinite&quot;:&quot;yes&quot;,&quot;speed&quot;:500,&quot;image_spacing_custom&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:20,&quot;sizes&quot;:[]},&quot;image_spacing_custom_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;image_spacing_custom_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}"
            data-widget_type="image-carousel.default" aria-roledescription="carousel"
            aria-label="Carousel | Horizontal scrolling: Arrow Left &amp; Right">
            <div class="elementor-widget-container">
              <VueSlickCarousel v-if="this,Prefix.Promotion.length > 0" :infinite="true" :swipe="true" :slidesPerRow="1" :slidesToShow="1"
            :autoplaySpeed="2000" :autoplay="true" :centerMode="false" :arrows="false" :dots="false">
            <div class="imgSlideCon" v-for="(item, i) in this,Prefix.Promotion" :key="i">
              <img class="imgSlide" :src="item.ImageUrl" draggable="false" />
            </div>
          </VueSlickCarousel>  
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-c3d83e9 e-flex e-con-boxed e-con e-parent" data-id="c3d83e9"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-3bcd46e e-con-full e-flex e-con e-child" data-id="3bcd46e"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
            <div
              class="elementor-element elementor-element-778d3b3 elementor-align-justify elementor-widget elementor-widget-button"
              data-id="778d3b3" data-element_type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a class="elementor-button elementor-button-link elementor-size-sm"
                    href="/register" target="_blank">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">สมัครสมาชิก</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-eb15322 e-con-full e-flex e-con e-child" data-id="eb15322"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
            <div
              class="elementor-element elementor-element-403d9a1 elementor-align-justify elementor-widget elementor-widget-button"
              data-id="403d9a1" data-element_type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a class="elementor-button elementor-button-link elementor-size-sm"
                    href="/login" target="_blank">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">เข้าสู่ระบบ</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-92b12e4 e-con-full e-flex e-con e-child" data-id="92b12e4"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
            <div
              class="elementor-element elementor-element-7a235e6 elementor-align-justify elementor-widget elementor-widget-button"
              data-id="7a235e6" data-element_type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a class="elementor-button elementor-button-link elementor-size-sm" v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank"
                    >
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">ติดต่อเรา</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       
    
      <div class="elementor-element elementor-element-cf17a7d e-flex e-con-boxed e-con e-parent" data-id="cf17a7d"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-7a64088 elementor-widget elementor-widget-heading"
            data-id="7a64088" data-element_type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">

              <h1 class="elementor-heading-title elementor-size-default">{{ appTitle }} เว็บตรง สล็อตออนไลน์
                แตกง่าย กับ pg slot</h1>
            </div>
          </div>
          <div class="elementor-element elementor-element-c7af496 elementor-widget elementor-widget-text-editor"
            data-id="c7af496" data-element_type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">

              <p><span style="font-weight: 400;">&nbsp; &nbsp; <a
                    href="/"><strong>{{ appTitle }}</strong></a>
                  ยินดีต้อนรับสู่เว็บ</span>ปั่นสล็อตที่ดีที่สุด<span
                  style="font-weight: 400;">&nbsp;ที่ให้คุณได้ร่วมเล่นเกมเดิมพัน </span>pg slot<span
                  style="font-weight: 400;"> ไปกับสล็อตออนไลน์เว็บตรง ได้เงินจริง
                  หนึ่งในเกมเดิมพันออนไลน์เล่นง่าย ที่ได้รับความนิยมมากๆ จากนักพนันทั่วโลก เพราะเราคือ
                  <strong>{{ appTitle }}</strong> ศูนย์รวบรวมค่ายเกมสล็อตออนไลน์ชั้นนำจากทั่วโลก
                  เราให้คุณได้เปิดโลกไปกับ</span>สล็อตเว็บตรง ฝาก-ถอน true wallet ไม่มีขั้นต่ํา<span
                  style="font-weight: 400;">
                  ที่จะตอบโจทย์ความต้องการของผู้เล่นและผู้ใช้บริการได้เป็นอย่างดี
                  แพลตฟอร์มของเรานำเสนอเกมที่หลากหลาย ให้คุณสนุกกับเกมการเดิมพันที่มีความหลากหลาย
                  และลุ้นรับรับรางวัลโบนัสสูงถึง 100 เท่า มีเกมเดิมพันให้คุณได้เลือกเล่นมากกว่า 500 เกม
                  ที่เราได้รวบรวมมาไว้ให้คุณ ก็สามารถเข้าเล่นและสมัครเว็บสล็อต PG ที่ดีที่สุด
                  ได้แล้ววันนี้</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-e058df0 e-flex e-con-boxed e-con e-parent" data-id="e058df0"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-52e792f e-flex e-con-boxed e-con e-child" data-id="52e792f"
            data-element_type="container"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
            <div class="e-con-inner">
              <div class="elementor-element elementor-element-4f1bbea elementor-widget elementor-widget-heading"
                data-id="4f1bbea" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">{{ appTitle }}
                    ไปกับโปรโมชั่นที่คุณไม่ควรพลาด</h2>
                </div> 
              </div>

     


              <div class="elementor-element elementor-element-16e2f3a elementor-widget elementor-widget-text-editor"
                data-id="16e2f3a" data-element_type="widget" data-widget_type="text-editor.default">
                <div class="elementor-widget-container">
                  <p>&nbsp; &nbsp; <a href="/"><strong>{{ appTitle }}</strong></a>
                    <span style="font-weight: 400;">ให้คุณสนุกได้แบบสุดๆ ไปกับโปรโมชั่นสุดคุ้มในการ
                    </span><strong>ปั่นสล็อต</strong><span style="font-weight: 400;">&nbsp;ที่น่าตื่นเต้นและเร้าใจ
                      เพิ่มโอกาสและเงินรางวัลได้มากยิ่งขึ้น
                      เรามีโปรโมชั่นมากมายที่ให้คุณได้เลือกรับได้อย่างไม่จำกัด
                      เรากล้ารับประกันว่าโปรโมชั่นของเราดีที่สุด และคุ้มที่สุดสำหรับคุณอย่างแน่นอน
                      ทำให้คุณมีสิทธิ์ลุ้นรับเงินรางวัลได้ทุกเวลา ฝาก-ถอนไม่มีขั้นต่ำ
                      ด้วยระบบที่ทันสมัยและใช้ง่ายได้จริง
                      บริการการเล่นเดิมพันออนไลน์ที่มีความน่าเชื่อถือ </span>สล็อตเว็บตรง แตกง่าย<span
                      style="font-weight: 400;"> แตกหนัก แตกจริง
                      สมัครสมาชิกใหม่พร้อมรับโปรโมชั่นได้อย่างไม่จำกัดตลอด 24 ชั่วโมง</span>
                  </p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-dea0e6e gallery-spacing-custom elementor-widget elementor-widget-image-gallery"
                data-id="dea0e6e" data-element_type="widget" data-widget_type="image-gallery.default">
                <div class="elementor-widget-container">

                  <div class="elementor-image-gallery">
                    <div id="gallery-1" class="gallery galleryid-33 gallery-columns-3 gallery-size-large">
                      <figure v-if="this,Prefix.Promotion.length > 0" v-for="(item, i) in this,Prefix.Promotion" :key="i+'ss'" class="gallery-item">
                        <div class="gallery-icon landscape">
                          <img loading="lazy" decoding="async" width="800" height="800"
                            :src="item.ImageUrl"
                            class="attachment-large size-large" alt=" " aria-describedby="gallery-1-229"
                             >
                        </div>
                        <figcaption class="wp-caption-text gallery-caption" id="gallery-1-229">
                          {{item.name}}
                        </figcaption>
                      </figure>
                       
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-7e8b94a e-flex e-con-boxed e-con e-parent" data-id="7e8b94a"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-a60341a elementor-widget elementor-widget-heading"
            data-id="a60341a" data-element_type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default">เริ่มต้นเล่น ปั่นสล็อต กับ {{ appTitle }}
                เว็บตรง ไม่ผ่านเอเย่นต์</h2>
            </div>
          </div>
          <div class="elementor-element elementor-element-9749226 elementor-widget elementor-widget-text-editor"
            data-id="9749226" data-element_type="widget" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              <p><span style="font-weight: 400;">&nbsp; &nbsp;
                  &nbsp;สนุกสนานและตื่นเต้นกับการเล่นสล็อตออนไลน์บนเว็บไซต์ <strong>{{ appTitle }}</strong>
                  ที่ไร้ขั้นต่ำในการฝากเงิน
                  คุณจะได้สัมผัสประสบการณ์การเล่นสล็อตออนไลน์ที่ไม่มีข้อจำกัดเลยทั้งในเรื่องของจำนวนเงินที่ต้องฝาก
                  และรวมถึงการถอนเงินที่อยากจะกดได้ตลอดเวลา
                  เพียงแค่เข้าสู่เว็บไซต์เลือกสล็อตออนไลน์ที่เชื่อมั่นโดยเลือกเล่นที่เว็บตรง
                  ไม่ผ่านเอเย่นต์ </span>สล็อตออนไลน์เว็บตรง<span style="font-weight: 400;">
                  ไม่ผ่านเอเย่นต์มีความน่าเชื่อถือที่สามารถมอบประสบการณ์ที่ยอดเยี่ยมให้กับคุณได้อย่างแน่นอน
                  อีกทั้งเรายังมีเกมสล็อตที่หลากหลายสไตล์ ทำให้คุณสามารถเลือกเล่นเกม PG SLOT ใหม่ล่าสุด
                  ได้อย่างไม่จำกัด</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-799fd08 e-flex e-con-boxed e-con e-parent" data-id="799fd08"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-f096ef6 e-flex e-con-boxed e-con e-child" data-id="f096ef6"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}">
            <div class="e-con-inner">
              <div class="elementor-element elementor-element-1936849 elementor-widget elementor-widget-heading"
                data-id="1936849" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h3 class="elementor-heading-title elementor-size-default">ปั่นสล็อตง่ายได้เงินจริง
                    สล็อตเว็บตรง สร้างเงินได้จากการปั่นสล็อต {{ appTitle }}</h3>
                </div>
              </div>
              <div class="elementor-element elementor-element-d656cf1 elementor-widget elementor-widget-text-editor"
                data-id="d656cf1" data-element_type="widget" data-widget_type="text-editor.default">
                <div class="elementor-widget-container">
                  <p>&nbsp; &nbsp; &nbsp;สล็อตเว็บตรง<span style="font-weight: 400;">
                      เป็นเกมคาสิโนออนไลน์ที่ได้รับความนิยมอย่างมากในปัจจุบัน
                      ด้วยรูปแบบเกมที่เล่นง่ายไม่ซับซ้อน แถมยังมีโอกาสลุ้นรับรางวัลใหญ่ได้ตลอดเวลา
                      ทำให้สล็อตออนไลน์กลายเป็นเกมที่ใครๆ ก็ต่างชื่นชอบ
                      ให้ความสนุกสนานและตื่นเต้นในการเล่นอย่างที่คุณต้องการ ให้คุณสร้างรายได้ได้จริง
                      ด้วยเทคโนโลยีที่ทันสมัยในปัจจุบัน ทำให้เราสามารถเล่นสล็อตออนไลน์ได้ง่ายๆ
                      ผ่านมือถือหรือคอมพิวเตอร์ ไม่ว่าจะอยู่ที่ไหนก็สามารถเข้าถึงเกมสล็อตได้
                      ความสุขที่ไม่สิ้นสุดของการปั่นสล็อตออนไลน์เพื่อสร้างเงินจริงกับเกมสล็อตออนไลน์ยอดนิยม</span>
                  </p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-d08d15e elementor-widget elementor-widget-image-carousel e-widget-swiper"
                data-id="d08d15e" data-element_type="widget"
                data-settings="{&quot;slides_to_show&quot;:&quot;4&quot;,&quot;navigation&quot;:&quot;none&quot;,&quot;image_spacing_custom&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:15,&quot;sizes&quot;:[]},&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;autoplay_speed&quot;:5000,&quot;infinite&quot;:&quot;yes&quot;,&quot;speed&quot;:500,&quot;image_spacing_custom_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;image_spacing_custom_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}"
                data-widget_type="image-carousel.default" aria-roledescription="carousel"
                aria-label="Carousel | Horizontal scrolling: Arrow Left &amp; Right">
                <div class="elementor-widget-container">

           <VueSlickCarousel :infinite="true" :swipe="true" :slidesPerRow="3" :slidesToShow="1"
            :autoplaySpeed="2000" :autoplay="true" :centerMode="false" :arrows="false" :dots="false">
            <div class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev" role="group"
                        aria-roledescription="slide" aria-label="1 / 4" data-swiper-slide-index="0" aria-hidden="true"
                        inert="" style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot1-punslot-1024x1024.webp" alt="jackpot1-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active" role="group"
                        aria-roledescription="slide" aria-label="2 / 4" data-swiper-slide-index="1" aria-hidden="true"
                        inert="" style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot2-punslot-1024x1024.webp" alt="jackpot2-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next" role="group"
                        aria-roledescription="slide" aria-label="3 / 4" data-swiper-slide-index="2" aria-hidden="true"
                        inert="" style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot3-punslot-1024x1024.webp" alt="jackpot3-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate" role="group" aria-roledescription="slide"
                        aria-label="4 / 4" data-swiper-slide-index="3" aria-hidden="true" inert=""
                        style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot4-punslot-1024x1024.webp" alt="jackpot4-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-prev" role="group" aria-roledescription="slide"
                        aria-label="1 / 4" data-swiper-slide-index="0" style="width: 353px; margin-right: 15px;"
                        aria-hidden="true" inert="">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot1-punslot-1024x1024.webp" alt="jackpot1-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-active" role="group" aria-roledescription="slide"
                        aria-label="2 / 4" data-swiper-slide-index="1" style="width: 353px; margin-right: 15px;"
                        aria-hidden="true" inert="">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot2-punslot-1024x1024.webp" alt="jackpot2-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-next" role="group" aria-roledescription="slide"
                        aria-label="3 / 4" data-swiper-slide-index="2" style="width: 353px; margin-right: 15px;"
                        aria-hidden="true" inert="">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot3-punslot-1024x1024.webp" alt="jackpot3-punslot"></figure>
                      </div>
                      <div class="swiper-slide" role="group" aria-roledescription="slide" aria-label="4 / 4"
                        data-swiper-slide-index="3" style="width: 353px; margin-right: 15px;" aria-hidden="true" inert="">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot4-punslot-1024x1024.webp" alt="jackpot4-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev" role="group"
                        aria-roledescription="slide" aria-label="1 / 4" data-swiper-slide-index="0"
                        style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot1-punslot-1024x1024.webp" alt="jackpot1-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active" role="group"
                        aria-roledescription="slide" aria-label="2 / 4" data-swiper-slide-index="1"
                        style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot2-punslot-1024x1024.webp" alt="jackpot2-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next" role="group"
                        aria-roledescription="slide" aria-label="3 / 4" data-swiper-slide-index="2"
                        style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot3-punslot-1024x1024.webp" alt="jackpot3-punslot"></figure>
                      </div>
                      <div class="swiper-slide swiper-slide-duplicate" role="group" aria-roledescription="slide"
                        aria-label="4 / 4" data-swiper-slide-index="3" style="width: 353px; margin-right: 15px;">
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/jackpot4-punslot-1024x1024.webp" alt="jackpot4-punslot"></figure>
                      </div>
          </VueSlickCarousel>  


                   
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-5c75818 e-flex e-con-boxed e-con e-parent" data-id="5c75818"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-8beb746 e-con-full e-flex e-con e-child" data-id="8beb746"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
            <div class="elementor-element elementor-element-e41c4ed elementor-widget elementor-widget-image"
              data-id="e41c4ed" data-element_type="widget" data-widget_type="image.default">
              <div class="elementor-widget-container">
                <img loading="lazy" decoding="async" width="800" height="800" src="/static/img/landing/punslot-pic2.webp"
                  class="attachment-large size-large wp-image-124" alt=" "
                   sizes="(max-width: 800px) 100vw, 800px">
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-4ee7433 e-con-full e-flex e-con e-child" data-id="4ee7433"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
            <div class="elementor-element elementor-element-03cfd35 elementor-widget elementor-widget-heading"
              data-id="03cfd35" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h3 class="elementor-heading-title elementor-size-default">ปั่นสล็อต เว็บตรง {{ appTitle }}
                  ให้บริการเกมสล็อต PG มากกว่า 500 เกม</h3>
              </div>
            </div>
            <div class="elementor-element elementor-element-36d0ff5 elementor-widget elementor-widget-text-editor"
              data-id="36d0ff5" data-element_type="widget" data-widget_type="text-editor.default">
              <div class="elementor-widget-container">
                <p><span style="font-weight: 400;">&nbsp; &nbsp; &nbsp;เว็บสล็อตที่ให้คุณ </span>ปั่นสล็อต
                  เว็บตรง<span style="font-weight: 400;"> ที่ดีที่สุดของเรา
                    เราได้คัดสรรเกมสล็อตมาให้คุณได้ทดลองเล่นสล็อตออนไลน์ไม่ผ่านเอเยนต์
                    สมัครฟรีโดยไม่ต้องลงทุน โดยมีเกมให้เลือกเล่นมากกว่า 500 เกม
                    และมีหลากหลายประเภทให้เลือกเล่น อาทิเช่น เกมสล็อต เกมยิงปลา
                    พร้อมให้คุณลุ้นรับโบนัสและแจ็คพอตรางวัลใหญ่ ได้ทุกช่วงเวลาของการเล่นอย่างแน่นอน
                  </span>{{ appTitle }}<span style="font-weight: 400;"> ให้บริการด้วยความสนุกสนานในทุกรูปแบบ
                    ยิ่งเล่นก็ยิ่งได้รับกำไรอย่างแน่นอน</span></p>
              </div>
            </div>
            <div class="elementor-element elementor-element-b522901 elementor-widget elementor-widget-heading"
              data-id="b522901" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h3 class="elementor-heading-title elementor-size-default">{{ appTitle }} ทดลองเล่นเกมสล็อต pg
                  ได้ทั้งวัน ไม่มีสะดุด</h3>
              </div>
            </div>
            <div class="elementor-element elementor-element-95b139d elementor-widget elementor-widget-text-editor"
              data-id="95b139d" data-element_type="widget" data-widget_type="text-editor.default">
              <div class="elementor-widget-container">
                <p><span style="font-weight: 400;">&nbsp; &nbsp; &nbsp;เกมสล็อต PG สล็อตเว็บตรง
                    เรามีให้เลือกมากมาย ทั้งเกมสล็อตคลาสสิกที่น่าทึ่ง และเกมสล็อตรูปแบต่างๆ ที่น่าสนใจ
                    ให้คุณเข้าทดลองเล่นเกมเกมที่คุณหลงใหลไปกับเว็บไซต์ของเรา
                    ที่ทำให้เพลิดเพลินไปกับสนุกสนานกับการเล่น
                    หากคุณกำลังมองหาประสบการณ์สล็อตที่ไม่ซ้ำใคร และต้องการที่จะตื่นเต้นตลอดทั้งวัน
                    แน่นอนว่า {{ appTitle }} เราเป็นเว็บไซต์ที่คุณต้องห้ามพลาด
                    มาร่วมประสบการณ์สนุกสนานกับการเล่นสล็อตออนไลน์แบบไม่จำกัดเวลากับทางเว็บไซต์นี้ตอนนี้
                    และพบกับความสนุกที่ไม่หมดสิ้นไปกับเรา
                    ด้วยเกมสล็อตคุณภาพที่รวดเร็วในการดำเนินเรื่องการเล่นและกราฟิกที่สวยงาม</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-element elementor-element-f9d8b83 e-flex e-con-boxed e-con e-parent" data-id="f9d8b83"
        data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}"
        data-core-v316-plus="true">
        <div class="e-con-inner">
          <div class="elementor-element elementor-element-977b9ec e-con-full e-flex e-con e-child" data-id="977b9ec"
            data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
            <div class="elementor-element elementor-element-fde404c elementor-widget elementor-widget-heading"
              data-id="fde404c" data-element_type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h3 class="elementor-heading-title elementor-size-default">นึกถึงเกม สล็อต คุณภาพต้องที่
                  {{ appTitle }}</h3>
              </div>
            </div>
            <div class="elementor-element elementor-element-57004a7 elementor-widget elementor-widget-text-editor"
              data-id="57004a7" data-element_type="widget" data-widget_type="text-editor.default">
              <div class="elementor-widget-container">
                <p><span style="font-weight: 400;">&nbsp; &nbsp;
                    &nbsp;ไม่ว่าคุณต้องการที่จะเล่นเกมสล็อตแบบไหน </span><b>{{ appTitle }}</b><span
                    style="font-weight: 400;"> ของเรามีให้คุณเลือกเล่นได้อย่างแน่นอน
                    เรารับรองว่าจะต้องถูกใจคุณ 100% เพราะเราได้รวบรวมเกมสล็อตคุณภาพ แตกง่าย ได้เงินจริง
                    ที่มาพร้อมกับโหมดให้คุณได้ทดลองเล่นได้ก่อนใคร
                    และลุ้นรับเงินรางวัลโบนัสมากกว่าใครที่เว็บของเรา สำหรับการสมัครเว็บสล็อต
                    ไม่ผ่านเอเย่นต์ เรามีแจกโปรโมชั่นสล็อตให้กับสมาชิกใหม่
                    ในการเข้าไปรับโบนัสสล็อตเครดิตฟรี ด้วยระบบอัตโนมัติที่ดีที่สุดของเรา
                    ที่มีเงื่อนไขไม่ยุ่งยาก บอกเลยว่าไม่เล่นไม่ได้แล้ว&nbsp;</span></p>
                <p><span style="font-weight: 400;">&nbsp; &nbsp; &nbsp;ถ้าไม่อยากพลาดรถไฟขบวนนี้กับสิ่งดีๆ
                    ที่มีให้ตลอดเส้นทาง ใครที่มองหาแหล่งของการหาเงิน รูปแบบใหม่ ที่ทั้งสนุก ทั้งมัน
                    และคุ้มค่า หรือการเล่นการพนันชิงเงินเดิมพันต่างๆ
                    คุณสามารถร่วมเล่นเกมสล็อตออนไลน์กับเราที่นี่ได้เลย
                    เรารับรองว่าคุณจะไม่รู้สึกถึงความซ้ำซากจำเจกับสิ่งเดิมๆ อย่างแน่นอน
                    เพราะมีตัวเลือกให้ได้เล่นกันอย่างมากมาย และพร้อมที่สุดด้วยเกมคุณภาพดี
                    ทั้งกราฟฟิกและการแตกของเกม เราได้คัดเลือกมาให้กับคุณมากที่สุด
                    ทั้งเกมที่มีให้ได้เล่นหรือจะเป็นข้อมูลต่างๆ ที่พร้อมบริการคุณตลอด 24 ชั่วโมง</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-elementor-type="footer" data-elementor-id="113" class="elementor elementor-113 elementor-location-footer"
      data-elementor-post-type="elementor_library">
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-536bfaab elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="536bfaab" data-element_type="section">
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-62c65fe5"
            data-id="62c65fe5" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div class="elementor-element elementor-element-7ce17d6c elementor-widget elementor-widget-text-editor"
                data-id="7ce17d6c" data-element_type="widget" data-widget_type="text-editor.default">
                <div class="elementor-widget-container">
                  <p>Copyright © 2023 Supported by {{ appTitle }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style=" 
    position: fixed;
    width: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
    bottom: 0px;z-index: 99;"
        class="elementor-section elementor-top-section elementor-element elementor-element-67f866a elementor-hidden-desktop elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="67f866a" data-element_type="section"
        data-settings="{&quot;sticky&quot;:&quot;bottom&quot;,&quot;sticky_on&quot;:[&quot;tablet&quot;,&quot;mobile&quot;],&quot;sticky_offset&quot;:0,&quot;sticky_effects_offset&quot;:0}">
        <div class="elementor-container elementor-column-gap-no">
          <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2375b037"
            data-id="2375b037" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-4ae4e945 elementor-align-justify elementor-widget elementor-widget-button"
                data-id="4ae4e945" data-element_type="widget" data-widget_type="button.default">
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a class="elementor-button elementor-button-link elementor-size-sm"
                      href="/login" target="_blank">
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">เข้าสู่ระบบ</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2f8c8fc6"
            data-id="2f8c8fc6" data-element_type="column">
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-68603c73 elementor-align-justify elementor-widget elementor-widget-button"
                data-id="68603c73" data-element_type="widget" data-widget_type="button.default">
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a class="elementor-button elementor-button-link elementor-size-sm"
                      href="/register" target="_blank">
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">สมัครสมาชิก</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getPrefix } from "@/services/modules/global.js";
import { reward } from "@/config/reward.js";
import carousel from "vue-owl-carousel";
import LoginForm from "@/components/form/LoginForm";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import RegisterForm from "@/components/form/RegisterForm";
// import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import carousel from "vue-owl-carousel";

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { PrefixMixins } from "@/mixins/Prefix.js";

// import { EffectCoverflow, Navigation, Pagination, Autoplay   } from "swiper";
// // import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
// import { Swiper, SwiperSlide} from 'swiper/vue';

import "swiper/swiper-bundle.css";
// SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow]);

// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import api from "@/services/index.js";

export default {
  name: "Index",
  mixins: [ PrefixMixins],

  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        navigation: false,

        autoplay: {
          delay: 1500,
        },
        centeredSlides: false,
        autoplayDisableOnInteraction: false,
        // direction: 'vertical',
        spaceBetween: 10,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      },

      availableBalance: "Loading...",
      availableCredit: "Loading...",
      isShowGame: true,
      chList: [],
      gameList: [],
      inGameList: false,
      ischName: "บริการของเรา",
      havelink: 0,
      gameListChunk: [],
      gameType: true,
      gameCH: this.$route.params.ch,
      chSlotList: [],
      gameCH: undefined,
      gameImg: "",
      gameType: "",
      gameCategory: "",
      productId: "",
      shareToken: this.$route.query.shareToken,
      category:
        this.$route.params.category == undefined
          ? "Casino"
          : this.$route.params.category,
      tab: 1,
    };
  },

  components: {
    Header,
    // Swiper,
    // SwiperSlide,
    VueSlickCarousel,
    Footer,
    LoginForm,
    RegisterForm,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "appTitle",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoCategory(category) {
      this.inGameList = false;
      this.category = category;
      this.$router.push(`/play/${category}`).catch(() => { });
    },

    gotoSub(route, item) {
      (this.gameImg = item.img
        .replace("game", "game_tranparent")
        .replace("game_betflik", "game_betflik_tranparent")),
        (this.gameType = item.gameType),
        (this.gameCategory = item.gameCategory),
        this.getGames(item.ch, item.gameType, item.category);
    },
    // async getChannels() {
    //   console.log("getChannels");

    //   await api
    //     .get("/user-profile-composite/v1/products")
    //     .then((v) => {
    //       if (v.success == true) {
    //         this.chList = v.data;
    //       } else {
    //         this.$swal.fire("แจ้งเตือน", v.message, "error");
    //       }
    //     })
    //     .catch((e) => {
    //       this.$swal.fire("แจ้งเตือน", e.message, "error");
    //     })
    //     .finally(() => {});
    // },
    async LoginGame(gameCode) {
      setTimeout(async () => {
        await api
          .get(`/user-profile-composite/v1/logIn/${this.productId}/${gameCode}`)
          .then((v) => {
            if (v.success == true) {
              if(v.data.url){
                setTimeout("location.href = '" + v.data.url + "';", 100);
              }else{
                this.$swal.fire("ไม่พบตัวเกม กรุณาลองใหม่อีกครั้ง", "", "error");
              }
            } else {
              this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            this.$swal.fire("แจ้งเตือน", e.message, "error");
          })
          .finally(() => { });
      }, 0);
    },
    async getGames(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }
        console.log("NO LOBBY");
        console.log(filter);
        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
      }
    },

    async getGamesPage(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }

        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              this.$router
                .replace(`/play/${this.category}/${filter}/${chId}`)
                .catch(() => { });
              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
        // this.$router.push({ name: 'play', params: { category: this.category } });
        // this.$router.replace(`/play/${this.category}/${filter}/${chId}`).catch(() => { });
      }
    },



  },
  async beforeCreate() {
    await api.get("/v2/prefix").then((v) => {
      if (v.success == true) {
        this.Prefix = v.data;
        //this.InitConfig();
      } else {
      }
    });
  },
  async mounted() {

    if (this.shareToken != undefined) {
      localStorage.setItem("shareToken", this.shareToken);
    } else {
      if (this.shareToken == undefined) {
        if (localStorage.getItem("shareToken")) {
          this.shareToken = localStorage.getItem("shareToken");
        }
      }
    }

    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }

    // await this.getChannels();

    if (this.$route.params.category != undefined) {
      this.category = this.$route.params.category;
      console.log(this.$route.params.category);

      if (
        this.$route.params.ch == undefined &&
        this.$route.params.gameType == undefined
      ) {
        console.log("chchch");
      } else {
        this.category = this.$route.params.category;
        this.inGameList = true;
        console.log("gameTypegameTypegameType");
        console.log(this.$route.params.gameType);
        console.log(this.$route.params.ch);
        this.getGames(
          this.$route.params.ch,
          this.$route.params.gameType,
          this.$route.params.category
        );
      }
    }
    $("#loginBtn").on("click", function () {
      $("#login").modal("show");
    });
    $("#registerBtn").on("click", function () {
      $("#register").modal("show");
    });
  },
  watch: {
    '$route.params.category': function (newParamValue, oldParamValue) {
      this.category = newParamValue
      // Do something when the query parameter changes
    },
    '$route.query.shareToken': function (newParamValue, oldParamValue) {
      this.shareToken = newParamValue
      // Do something when the query parameter changes
    }
  },
};
</script>
<style>
.modal-backdrop.show,
.overlaymodal {
  z-index: 0;
}

img {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.imgSlide {
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.imgSlideCon {
  padding-left: 5px;
  padding-right: 5px;

}
img {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/Index.vue